import { LitElement, html, css, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../../core/jobindsats-element';
import { DimensionOption } from '../model/dimension-option-type';
import { AreaTabOption } from '../model/area-tab-option-type';

@customElement('maaling-area-selection-element')
export class MaalingAreaSelectionElement extends JobindsatsElement(LitElement) {
    static styles = css`
        .area-container {
          padding: 20px 30px 30px;
        }
        .area-border {
            border: thin solid var(--main-blue-25);
            padding: 25px;
            padding-bottom: 0px;
            border-spacing: 0;
        }
        .tab-area-extension {
            display: block;
        }
        .dropdown-area-extension {
            display: none;
            padding: 20px 24px 15px;
        }
         @media only screen and (max-width:  1300px) {
                    .tab-area-extension {
                        display: none;
                    }
                    .dropdown-area-extension {
                        display: block;
                    }
                    .area-container {
                        padding-left: 20px;
                        padding-right: 20px;
                        padding-top: 10px;
                        padding-bottom: 40px;
                    }
        }
        @media only screen and (max-width: 375px) {
            .area-container {
                padding: 5px;
            }
            .area-border {
                padding: 5px;
            }
        }
    `;

    @state()
    dropdownOptions: { key: string; name: string }[] = [];

    @state()
    selectedTab?: string;

    @state()
    selectedSorting?: string;

    litElement?: TemplateResult;

    @property({
        type: Array,
    })
    areas?: AreaTabOption[];

    @state()
    groups: DimensionOption[] = [];

    init : Boolean = true;

    @state()
    selectedAreas: Map<string, boolean> = new Map();

    connectedCallback() {
        super.connectedCallback();
    }
    constructor() {
        super();
    }

    render() {
        // TODO: Can this be optimized/moved? 
        if (this.init && this.areas &&  this.areas[0]) {
            this.selectedTab = this.areas[0].key;
            if (this.selectedTab) {
                this.contentGenerator(this.selectedTab);
            }
            this.init = false;
        }
        if (this.areas && this.areas.length) {
            return html`
                <ji-dropdown-element
                    expanded="true"
                    title="Område"
                    class="dropdown-area-extension"
                    .options=${this.areas} 
                    selected-period=${this.selectedTab} 
                    @option-selected=${this.handleTabSelection}>
                </ji-dropdown-element>

                <ji-tab-element
                    class="tab-area-extension"
                    databank="true"
                    .options=${this.areas} 
                    @tab-selected=${this.handleTabSelection}>
                </ji-tab-element>
            
                <div class="area-container">
                    <div class="area-border">
                        <maaling-dropdown-element
                            .dropdownOptions=${this.dropdownOptions} 
                            @item-selected="${this.handleSortingSelection}"> 
                        </maaling-dropdown-element>
            
                        <dimension-manager
                           .groups=${this.groups} 
                           .groupNotReturnedAsNull=${true} 
                           selectedPeriod=${this.selectedTab}
                           .activeTab=${this.selectedTab}
                           @options-selected=${(ev: CustomEvent) => this.handleOptionSelected(ev)}>
                        </dimension-manager>
                    </div>
                </div>
            `;
        } else {
            return html`
                 <div class="area-container">
                           Ingen områder tilknyttet måling
                </div>`;
        }
    }

    handleOptionSelected(ev: CustomEvent) {

        const options: DimensionOption[] = ev.detail.options;
        const areas: string[] = [];

        function getSelectedAreas(option : DimensionOption) {
            if (option.selected) {
                areas.push(option.name);
            }
            if (!option.children) {
                return;
            }

            option.children.forEach(child => getSelectedAreas(child));
        }

        if (options != null) {
            options.forEach(child => getSelectedAreas(child));
        }
        this.groups = options;
        this.emitOptionsChangedEvent(areas);

    }

    emitOptionsChangedEvent(areas: string[]) {
        const areasSelectedEvent = new CustomEvent('areas-selected', {
            detail: {
                areas: areas
            },
            composed: true,
            bubbles: true,
        });
        this.dispatchEvent(areasSelectedEvent);
    }


    handleTabSelection(ev: CustomEvent) {
        const clickedTab = ev.detail.key as string;
        if (this.selectedTab !== clickedTab) {
            this.selectedTab = clickedTab;
            this.dropdownOptions = [];
            this.areas = this.areas?.map(areaType => {
                if (areaType.key === this.selectedTab) {
                    return {
                        ...areaType,
                        selected: true,
                    };
                } else {
                    return {
                        ...areaType,
                        selected: false,
                    };
                }
            });
        }


        this.areas?.forEach(area => {
            area.options?.forEach(areaOption => {
                areaOption.selected = false;
            });
        });
        this.emitTabGroupChangedEvent();
        this.contentGenerator(this.selectedTab as string);
    }

    emitTabGroupChangedEvent() {
        const tabGroupChangedEvent = new CustomEvent('tab-selected', {
            detail: {
                areas: this.areas
            },
            composed: true,
            bubbles: true,
        });
        this.dispatchEvent(tabGroupChangedEvent);
    }

    handleSortingSelection(ev: CustomEvent) {
        this.selectedSorting = ev.detail.key as string;
        this.areas?.find(group => {
            if (group.sortGroups && group.key === this.selectedTab) {
                group.sortGroups.forEach(sortGroup => {
                    if (sortGroup.dimensionSortGroupId === this.selectedSorting) {
                        this.groups = sortGroup.children ?? [];
                    }
                });
            }
        });
    };

    contentGenerator(tabKey: string) {
        this.areas?.forEach(group => {
            // If tab have sorting options shown them in dropdown
            if (group.key === tabKey && group.sortGroups) {
                group.sortGroups.forEach(sortGroup => {
                    this.dropdownOptions?.push({
                        key: sortGroup.dimensionSortGroupId,
                        name: sortGroup.dimensionSortGroupTitle
                    });
                    if (sortGroup.selected) {
                        this.selectedSorting = sortGroup.dimensionSortGroupId;
                        this.groups = sortGroup.children ?? [];
                    }
                });
            }
            // If tab have no dropdown just show options
            else if (group.key === tabKey && group.options) {
                this.groups = group.options;
            }
        });
    }
}